import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { View, StyleSheet } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import {
  Cronometro,
  ImageComponent,
  InfoComponent,
  SCREEN_IDS,
} from "../components/FullComponent.js";
import moment from "moment";
import AppScreenBackground from "../components/Common/ComponentAppBackground.jsx";
import { translateText } from "../translations/translationService";
import { CRIMPING_SCREEN_COLORS } from "../style/colors.js";

export default function TimeWorkScreen({ route }) {
  const dispatch = useDispatch();
  const infoData = useSelector((state) => state.infoData.infoData);
  const { tiempos, ...data } = infoData;
  const lang = useSelector((state) => state.lang.value);
  const ArrayDataTime = tiempos
    .filter(({ tipo_tiempo }) => tipo_tiempo === "CRIMPING")
    .map(
      ({
        usuario,
        team,
        codigo,
        fecha_ini,
        fecha_fin,
        duracion,
        cantidad_proceso,
      }) => {
        const StartDate = moment(fecha_ini.date);
        const EndDate = moment(fecha_fin.date);

        const formattedStartDate = StartDate.isValid()
          ? StartDate.format("DD/MM/YY HH:mm")
          : "-";
        const formattedEndDate = EndDate.isValid()
          ? EndDate.format("DD/MM/YY HH:mm")
          : "-";

        const formattedDuration = duracion?.date
          ? moment(duracion.date).format("HH:mm:ss")
          : "-";

        return {
          usuario: usuario || "",
          equipo: team || "",
          codigo: codigo || "",
          inicio: formattedStartDate || "-",
          fin: formattedEndDate || "-",
          duracion: formattedDuration || "",
          cantidad_proceso: cantidad_proceso
            ? Number(cantidad_proceso).toFixed(1)
            : "-",
        };
      }
    );

  const currentScreenId = SCREEN_IDS.CRIMPING;

  const TableComponent = () => (
    <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
      <Table stickyHeader size='small'>
        <TableHead>
          <TableRow sx={{ backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Operario", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Equipo", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Inicio", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Fin", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Tipo", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Duracion", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ fontWeight: "bold", backgroundColor: CRIMPING_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              {translateText("Cantidad", lang)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ArrayDataTime.map((item, index) => (
            <TableRow key={index}>
              <TableCell align='center'>{item.usuario}</TableCell>
              <TableCell align='center'>{item.equipo}</TableCell>
              <TableCell align='center'>{item.inicio}</TableCell>
              <TableCell align='center'>{item.fin}</TableCell>
              <TableCell align='center'>{item.codigo}</TableCell>
              <TableCell align='center'>{item.duracion}</TableCell>
              <TableCell align='center'>{item.cantidad_proceso}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <AppScreenBackground style={{ flex: 1 }}>
      <View style={styles.container}>
        <View style={[styles.row]}>
          <View style={[styles.column, { flex: 1 }]}>
            <InfoComponent data={data} />
          </View>
          <View style={[styles.column, { marginLeft: 20, flex: 1 }]}>
            <ImageComponent data={data} />
          </View>
        </View>
        <View>
          <Cronometro
            screen={currentScreenId}
            listData={data.eFabrica}
            po={data.PO}
            mo={data.MO}
          />
          <TableComponent />
        </View>
      </View>
    </AppScreenBackground>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: CRIMPING_SCREEN_COLORS.BORDER_MEDIUM,
    paddingVertical: 10,
  },

  container: {
    flex: 1,
    padding: 10,
  },
  column: {
    flexDirection: "column",
  },
});
